import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDoAndDont16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDoAndDont16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.854 7.857a.5.5 0 0 1-.707 0L5.379 6.089 3.611 7.856a.5.5 0 0 1-.707-.707l1.768-1.767-1.768-1.768a.5.5 0 1 1 .707-.707L5.38 4.675l1.768-1.768a.5.5 0 0 1 .707.707L6.086 5.382 7.854 7.15a.5.5 0 0 1 0 .707m5.756.996a.5.5 0 0 0-.708-.707L10.19 10.86 8.853 9.525a.5.5 0 0 0-.707.707l1.689 1.689.353.353.354-.353z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDoAndDont16);
